import * as ActionTypes from '../actions/actionTypes';

const initialState = {
  dragging: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.START_TIMELINE_DRAG:
      return { ...state, dragging: true };

    case ActionTypes.STOP_TIMELINE_DRAG:
      return { ...state, dragging: false };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/timeline_dnd.js